<template>
 <v-col :cols="12" :sm="12" :md="12">
    <DataTable 
    :classTitle="'UnidadeMedida'"
    :tableTitle="'Unidade de Medida'" 
    :newRowButtonText="'Nova Unidade de medida'"
    :tableHeader="headers"
    :tableData="unidadesMedida"
    :modalFormComposition="formComposition"
    :onUpdate="update"
    :onInsert="insert"
    :onDelete="deleteItem"
    :onUpdateDataTable="UpdateDataTable"
    

    ></DataTable>
 </v-col>
</template>

<script>
  import axios from '../plugins/axios'
  import DataTable from '../components/Datatable.vue'
  import store from '@/store/index'
  export default {

   components: {
     DataTable
  },

    data: () => ({
      // Cabeçalho da DataTable
      headers: [
        {
          text: 'ID',
          value: 'numeroUnidadeMedida',
        },
        {
          text: 'Nome',
          value: 'nomeUnidadeMedida',
        },
        { text: 'Descrição', value: 'descricaoUnidadeMedida' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],

      //Form composition
      formComposition: [
        {
          title: 'Titulo unidade de medida', // Titulo da label
          type: 'text', // Tipo do Input
          size: 6, // Tamanho da coluna 
          modelName: 'nomeUnidadeMedida'
        },
        {
          title: 'Descrição unidade de medida',
          type: 'text',
          size: 6,
          modelName: 'descricaoUnidadeMedida'
        }
      ], 

      //Array populado pela função initialize 
      unidadesMedida: []
    }),

    created () {
      this.initialize()
    },

    methods: {
      async initialize(){  
          try {
              var config = {
                headers : {
                  "Content-Type": "application/json",
                  "x-auth-token": store.state.token
                }
              }
            const response = await axios.get('unidadeMedida', config)
            this.unidadesMedida = response.data
          } catch (error) {
            console.log(error)
          }
      },

      async UpdateDataTable(){
         try {
              var config = {
                headers : {
                  "Content-Type": "application/json",
                  "x-auth-token": store.state.token
                }
              }
            const response = await axios.get('unidadeMedida', config)
            return response.data
          } catch (error) {
            console.log(error)
          }
      },

         async insert (reciveItem) {
          try {
            var config = {
                headers : {
                  "Content-Type": "application/json",
                  "x-auth-token": store.state.token
                }
              }

            await axios.post('unidadeMedida', reciveItem, config)
            return true
          } catch (error) {
            console.log(error)
          }
        },

        async update(reciveItem){
          try {
            var config = {
                headers : {
                  "Content-Type": "application/json",
                  "x-auth-token": store.state.token
                }
            }
            await axios.put('unidadeMedida', reciveItem, config)
            return true
          } catch (error) {
            console.log(error)

          }
        },

      async deleteItem (reciveItem) {
          try {
            var config = {
                headers : {
                  "Content-Type": "application/json",
                  "x-auth-token": store.state.token
                }
            }
            await axios.delete('unidadeMedida', {data: reciveItem, headers: config.headers})
            return true
          
          } catch(error){
            console.log(error)

          } finally{ 
            this.initialize()
          }
      }

    }
  }
</script>